import React, { FC, useContext, useEffect, useMemo, useRef, useState } from "react";
import Slider, { Settings } from "react-slick";
import { useDataSlider } from "../../main-cover-hook";
import { MainCover6Props, MainCover6Type } from "../../main-cover.types";
import styles from "./main-cover-3.module.css";
import { LazyVideo } from "../../../../";
import WidgetContainer from "../../../widget-container";
import { ContentCoverContext } from "../../main-cover.context";
import { UiButton } from "@ui-monorepo/components";
import ArrowsSliderCover from "../components/arrows-slider-covers/arrows-slider-covers";

const MainCover3: FC<MainCover6Props> = ({ classTypeName }) => {
  const { theme, isMobile, storeMetadata, stepToPause } = useContext(ContentCoverContext);
  const { items, handleClickScroll } = useDataSlider();
  const sliderRef = useRef<Slider>(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings: Settings = {
    infinite: true,
    slidesToShow: 1,
    dots: true,
    autoplay: true,
    adaptiveHeight: true,
    speed: 400,
    pauseOnHover: true,
    prevArrow: <ArrowsSliderCover userTheme={theme} />,
    nextArrow: <ArrowsSliderCover userTheme={theme} />,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }],

    beforeChange: (current, next) => setActiveSlide(next)
  };

  const videoIsActive = useMemo(() => {
    return !!items[activeSlide]?.video;
  }, [activeSlide, items]);

  useEffect(() => {
    if (!!stepToPause || stepToPause === 0) {
      sliderRef?.current?.slickGoTo(stepToPause);
      sliderRef?.current?.slickPause();
    } else {
      sliderRef?.current?.slickPlay();
    }
  }, [stepToPause]);

  useEffect(() => {
    if (videoIsActive) {
      sliderRef.current?.slickPause();
    } else {
      sliderRef.current?.slickPlay();
    }
  }, [videoIsActive]);

  return (
    <WidgetContainer className={styles.widgetContainer} withoutPaddingX>
      <div className={`${styles.mainBannerOnixStyles} ${styles.mainCover3Container} ${styles[classTypeName]}`}>
        <Slider ref={sliderRef} {...settings}>
          {items.map((item, index) =>
          <div key={`${index}-slider`}>
              <div className={styles.sliderCard}>
                <div className={`${styles.sliderImg} ${item?.video ? `${styles.sliderZnone}` : `${styles.sliderZ}`}`}>
                  {item?.video &&
                <LazyVideo
                  videoUrl={item.video}
                  play={videoIsActive}
                  storeMetadata={storeMetadata}
                  className={`${MainCover6Type.lines ? "line" : "slider"}`}
                  theme={theme} />}


                  {item?.imageDesktop && !isMobile &&
                <img src={item?.imageDesktop} className={styles.portraitImg} alt={"slider-img"} loading='eager' />}

                  {item?.imageMobile && isMobile &&
                <img src={item?.imageMobile} className={styles.portraitImg} alt={"slider-img"} loading='eager' />}

                </div>
                {!item.video && (item.config?.enabled || item.config?.enabled_button) &&
              <div className={styles.sliderBox}>
                    <div className={`${styles[item.config?.position || "center"]} ${styles.sliderBoxTitle}`}>
                      {item.config?.enabled && item.title &&
                  <div className={styles.sliderBoxTitleText}>
                          {item.title && <h1 className={styles.sliderWelcome}>{item?.title}</h1>}
                        </div>}

                      {item.config?.enabled_button && item.link ?
                  <UiButton
                    isFilled
                    onClick={() => handleClickScroll(item.link?.value, item.link?.elementId)}
                    theme={theme}>

                          <div className={styles.sliderSellerBtnText}>{item?.link?.label}</div>
                        </UiButton> :
                  null}
                    </div>
                  </div>}

              </div>
            </div>
          )}
        </Slider>
      </div>
    </WidgetContainer>);

};

export default MainCover3;